import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "date-picker-container p-ml-2 p-mb-5" }
const _hoisted_2 = { class: "p-field p-grid" }
const _hoisted_3 = {
  for: "startDate",
  class: "kn-material-input-label p-col-12  p-md-1 p-mb-md-0"
}
const _hoisted_4 = {
  key: 0,
  class: "p-error p-grid p-mt-1"
}
const _hoisted_5 = { class: "p-col-12" }
const _hoisted_6 = { class: "p-field p-grid" }
const _hoisted_7 = {
  for: "endDate",
  class: "kn-material-input-label p-col-12  p-md-1 p-mb-md-0"
}
const _hoisted_8 = {
  key: 0,
  class: "p-error p-grid p-mt-1"
}
const _hoisted_9 = { class: "p-col-12" }
const _hoisted_10 = { class: "p-d-flex p-grid p-mt-5" }
const _hoisted_11 = { class: "p-mx-2" }
const _hoisted_12 = {
  for: "repeatInterval",
  class: "kn-material-input-label p-m-2"
}
const _hoisted_13 = {
  key: 0,
  class: "p-field"
}
const _hoisted_14 = {
  for: "weekdays",
  class: "kn-material-input-label "
}
const _hoisted_15 = {
  key: 1,
  class: "p-field"
}
const _hoisted_16 = {
  for: "months",
  class: "kn-material-input-label"
}
const _hoisted_17 = {
  key: 2,
  class: "p-field"
}
const _hoisted_18 = {
  for: "days",
  class: "kn-material-input-label  "
}
const _hoisted_19 = {
  key: 3,
  class: "p-field"
}
const _hoisted_20 = {
  for: "hours",
  class: "kn-material-input-label"
}
const _hoisted_21 = {
  key: 4,
  class: "p-field p-ml-2"
}
const _hoisted_22 = {
  for: "minutes",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_MultiSelect = _resolveComponent("MultiSelect")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, { class: "p-m-2" }, {
    content: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('cron.startDate')) + ": ", 1),
          _createVNode("span", null, [
            _createVNode(_component_Calendar, {
              id: "startDate",
              class: ["kn-material-input", {
                                'p-invalid': !_ctx.validDates
                            }],
              modelValue: _ctx.startTemp,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.startTemp = $event)),
              style: {"width":"20rem"},
              showIcon: true,
              manualInput: true,
              onDateSelect: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setDate($event, 'startDate')))
            }, null, 8, ["modelValue", "class"]),
            (!_ctx.validDates)
              ? (_openBlock(), _createBlock("div", _hoisted_4, [
                  _createVNode("small", _hoisted_5, _toDisplayString(_ctx.$t('kpi.kpiScheduler.dateError')), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('cron.endDate')) + ": ", 1),
          _createVNode("span", null, [
            _createVNode(_component_Calendar, {
              id: "endDate",
              class: ["kn-material-input", {
                                'p-invalid': !_ctx.validDates
                            }],
              modelValue: _ctx.endTemp,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.endTemp = $event)),
              style: {"width":"20rem"},
              showIcon: true,
              manualInput: true,
              showButtonBar: true,
              onDateSelect: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setDate($event, 'endDate')))
            }, null, 8, ["modelValue", "class"]),
            (!_ctx.validDates)
              ? (_openBlock(), _createBlock("div", _hoisted_8, [
                  _createVNode("small", _hoisted_9, _toDisplayString(_ctx.$t('kpi.kpiScheduler.dateError')), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, [
          _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('managers.functionalitiesManagement.execution')) + ": ", 1),
          _createVNode("span", null, [
            _createVNode(_component_Dropdown, {
              id: "repeatInterval",
              class: "kn-material-input",
              style: _ctx.knCronDescriptor.style.intervalInput,
              modelValue: _ctx.scheduling.repeatInterval,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.scheduling.repeatInterval = $event)),
              optionLabel: "name",
              optionValue: "value",
              options: _ctx.knCronDescriptor.intervals,
              onChange: _ctx.updateCronInterval
            }, null, 8, ["style", "modelValue", "options", "onChange"])
          ])
        ]),
        (_ctx.scheduling.repeatInterval === 'week')
          ? (_openBlock(), _createBlock("div", _hoisted_13, [
              _createVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('cron.inWeekday')), 1),
              _createVNode(_component_MultiSelect, {
                id: "weekdays",
                class: "kn-material-input p-mx-2",
                style: {"max-width":"8rem"},
                modelValue: _ctx.scheduling.weekdaysSelected,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.scheduling.weekdaysSelected = $event)),
                options: _ctx.weekdays,
                optionLabel: "label",
                optionValue: "value",
                placeholder: _ctx.$t('common.default'),
                onChange: _ctx.formatCronForSave
              }, null, 8, ["modelValue", "options", "placeholder", "onChange"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.scheduling.repeatInterval === 'month')
          ? (_openBlock(), _createBlock("div", _hoisted_15, [
              _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('cron.inMonth')), 1),
              _createVNode(_component_MultiSelect, {
                id: "months",
                class: "kn-material-input p-mx-2",
                style: {"max-width":"8rem"},
                modelValue: _ctx.scheduling.monthsSelected,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.scheduling.monthsSelected = $event)),
                options: _ctx.months,
                optionLabel: "label",
                optionValue: "value",
                placeholder: _ctx.$t('common.default'),
                onChange: _ctx.formatCronForSave
              }, null, 8, ["modelValue", "options", "placeholder", "onChange"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.scheduling.repeatInterval === 'day' || _ctx.scheduling.repeatInterval === 'month')
          ? (_openBlock(), _createBlock("div", _hoisted_17, [
              _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('cron.inDay')), 1),
              _createVNode(_component_MultiSelect, {
                id: "days",
                class: "kn-material-input p-mx-2",
                style: {"max-width":"8rem"},
                modelValue: _ctx.scheduling.daysSelected,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.scheduling.daysSelected = $event)),
                options: _ctx.days,
                placeholder: _ctx.$t('common.default'),
                onChange: _ctx.formatCronForSave
              }, null, 8, ["modelValue", "options", "placeholder", "onChange"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.scheduling.repeatInterval && _ctx.scheduling.repeatInterval != 'minute')
          ? (_openBlock(), _createBlock("div", _hoisted_19, [
              _createVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('cron.inHour')), 1),
              _createVNode(_component_MultiSelect, {
                id: "hours",
                class: "kn-material-input p-mx-2",
                style: {"max-width":"8rem"},
                modelValue: _ctx.scheduling.hoursSelected,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.scheduling.hoursSelected = $event)),
                options: _ctx.hours,
                placeholder: _ctx.$t('common.default'),
                onChange: _ctx.formatCronForSave
              }, null, 8, ["modelValue", "options", "placeholder", "onChange"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.scheduling.repeatInterval)
          ? (_openBlock(), _createBlock("div", _hoisted_21, [
              _createVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('cron.inMinute')), 1),
              _createVNode(_component_MultiSelect, {
                id: "minutes",
                class: "kn-material-input p-mx-2",
                style: {"max-width":"8rem"},
                modelValue: _ctx.scheduling.minutesSelected,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.scheduling.minutesSelected = $event)),
                options: _ctx.minutes,
                placeholder: _ctx.$t('common.default'),
                onChange: _ctx.formatCronForSave
              }, null, 8, ["modelValue", "options", "placeholder", "onChange"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}